/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
// tslint:disable:no-any
/**
 * class to detect the number of listeners for events
 */
export class EventWatcher {
    /**
     * constructor
     * @param element the element to observe for listeners
     */
    constructor(element) {
        this._eventListeners = {};
        this._domElement = element;
        // ** Event optimization to avoid unnecessary calculations if none is registered */
        this._domElement.realAddEventListener = this._domElement.addEventListener;
        this._domElement.realRemoveEventListener = this._domElement.removeEventListener;
        this._domElement.addEventListener = (type, listener, options) => {
            if (!this._eventListeners[type]) {
                this._eventListeners[type] = 0;
            }
            this._eventListeners[type]++;
            this._domElement.realAddEventListener(type, listener, options);
        };
        this._domElement.removeEventListener = (type, listener, options) => {
            if (!!this._eventListeners[type]) {
                this._eventListeners[type]--;
                this._domElement.realRemoveEventListener(type, listener, options);
            }
        };
    }
    /**
     * returns if an event has listeners
     * @param type type (name) of the event
     */
    hasListeners(type) {
        return !!this._eventListeners[type] && this._eventListeners[type] > 0;
    }
    /**
     * return the number of registered listeners for an event
     * @param type type (name) of the event
     */
    getListenerCount(type) {
        return !!this._eventListeners[type] ? this._eventListeners[type] : 0;
    }
}
//# sourceMappingURL=EventWatcher.js.map